import { LoadingDarkBg } from "components/front/layout/DarkBackground";
import { Props as FooterProps } from "components/front/layout/Footer";
import { GeneralFoot } from "components/front/layout/GeneralFoot";
import GeneralHead from "components/front/head/GeneralHead";
import { Header } from "components/front/layout/Header";
import Main from "components/front/layout/Main";
import { Props as MessagePanelProps } from "components/front/mypage/MessagePanel";
import { Props as MypageContentProps } from "components/front/mypage/MypageContent";
import {
  getMypageScreenName,
  MESSAGE_TAB,
  MessageTab,
  MYPAGE_TABS,
  MypageTabType,
  ProfileEditTab,
  SupportTab,
} from "components/front/mypage/MypageTabs";
import { Props as ProfileEditPanelProps } from "components/front/mypage/ProfileEditPanel";
import { Props as SupportPanelProps } from "components/front/mypage/SupportPanel";
import CookieHandler from "lib/cookie";
import { FrontAuthProps, useFrontAuthContext, withFrontAuth } from "lib/hoc/withFrontAuth";
import { warningToast } from "lib/toast";
import { GetServerSideProps, NextPage } from "next";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import * as queryString from "querystring";

const ProfileEditPanel = dynamic<ProfileEditPanelProps>(() => import("components/front/mypage/ProfileEditPanel"));
const MessagePanel = dynamic<MessagePanelProps>(() => import("components/front/mypage/MessagePanel"));
const SupportPanel = dynamic<SupportPanelProps>(() => import("components/front/mypage/SupportPanel"));
const DarkBackground = dynamic<Record<string, never>>(() => import("components/front/layout/DarkBackground"), {
  ssr: false,
  loading: LoadingDarkBg,
});
const MypageContent = dynamic<MypageContentProps>(() => import("components/front/mypage/MypageContent"), { ssr: false });
const Footer = dynamic<FooterProps>(() => import("components/front/layout/Footer"));

const MyPage: NextPage<{ notice: string } & FrontAuthProps> = ({ notice, reloadFrontAuth }) => {
  const router = useRouter();
  const [selectedTab, setSelectedTab] = useState<MypageTabType>(MESSAGE_TAB);
  const member = useFrontAuthContext();
  useEffect(() => {
    const dist = queryString.parse(router.asPath.split(/\?/)[1])["tab"] as string;
    const targetTab = MYPAGE_TABS.find((tab) => tab === dist) || MESSAGE_TAB;
    setSelectedTab(targetTab);
  }, [router.asPath]);
  useEffect(() => {
    if (notice) {
      warningToast(notice);
    }
  }, []);
  const screenName = useMemo(() => getMypageScreenName(selectedTab), [selectedTab]);
  return (
    <>
      <GeneralHead screenName={screenName + " | マイページ"} />
      <Header />
      <DarkBackground />
      <Main>
        <Section>
          <MypageContent onChangeAvatar={reloadFrontAuth} />
          <Tabs>
            <ProfileEditTab selectedTab={selectedTab} />
            <MessageTab selectedTab={selectedTab} />
            <SupportTab selectedTab={selectedTab} />
          </Tabs>
          {member && <ProfileEditPanel selectedTab={selectedTab} member={member} successCallback={reloadFrontAuth} />}
          <MessagePanel selectedTab={selectedTab} />
          <SupportPanel selectedTab={selectedTab} />
        </Section>
      </Main>
      <Footer />
      <GeneralFoot />
    </>
  );
};
export const getServerSideProps: GetServerSideProps<{
  notice: string;
}> = async (context) => {
  const cookieHandler = new CookieHandler(context);
  const notice = cookieHandler.oneTimeNotice();
  return { props: { notice } };
};

export default withFrontAuth(MyPage, { doRedirect: true });

const Section = styled.section`
  @media screen and (max-width: 960px) {
    width: 100%;
    padding: 20px 0 0;
  }
  @media screen and (min-width: 961px) {
    width: 960px;
    margin: 0 auto;
    padding: 40px 0 80px 0;
  }
  @media screen and (min-width: 1281px) {
    width: 1080px;
  }
  @media screen and (min-width: 1921px) {
    width: 1280px;
  }
`;
const Tabs = styled.div`
  width: 100%;
  height: 30px;
  padding: 0 10px;
  display: flex;
  @media screen and (min-width: 1281px) {
    height: 32px;
  }
  @media screen and (min-width: 1921px) {
    height: 36px;
  }
`;
